import React, { useContext } from "react";
import Start from "./Start";
import { GameContext } from "./Context/GameContext";
import EventManagement from "./Routes/Events/EventManagement";

type Props = {
    admin: boolean;
};

const RefreshSettings = ({ admin }: Props) => {

  const { eventName, hasLoadedRoomStates } = useContext(GameContext);

  if (!hasLoadedRoomStates) return null;

  return eventName ? <Start /> : <EventManagement admin={admin} />;
};

export default RefreshSettings;
